import { Controller } from "@hotwired/stimulus"
import { installManager, installationPlatform } from "../pwa_install.js"

export default class extends Controller {
  static targets = ["button", "status", "guide"]
  static values = { messages: Object }

  connect() {
    const platform = installationPlatform(navigator)
    this.guideTargets.forEach(guide => { guide.open = guide.dataset.platform === platform })
    this.unsubscribe = installManager.subscribe(snapshot => this.render(snapshot))
    // Anonymous visitors also need the existing PWA worker registered.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(error => {
        console.warn("Unable to register installation support", error)
      })
    }
  }

  disconnect() {
    this.unsubscribe?.()
  }

  install() {
    installManager.install()
  }

  render({ state, available }) {
    const buttonFocused = document.activeElement === this.buttonTarget
    this.statusTarget.textContent = this.messagesValue[state]
    this.buttonTarget.hidden = !available || state === "standalone"
    this.buttonTarget.disabled = !available || state === "standalone"
    if (buttonFocused && this.buttonTarget.hidden) this.statusTarget.focus()
  }
}
